import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import * as firebase from 'firebase'

import { DataLoader } from '@fibo-app/fibo-collab-shared'

class FirebaseGcalSettingsManager extends React.Component {

  calendarsLoader : DataLoader
  accessLoader : DataLoader

  static propTypes = {
    userId: PropTypes.string,
    teamId: PropTypes.string,
    dispatch: PropTypes.func.isRequired
  }

  constructor(props : Object) {
    super(props)
    this.checkProps(undefined, props.userId, undefined, props.teamId)
  }

  componentWillReceiveProps(nextProps) {
    this.checkProps(this.props.userId, nextProps.userId,
      this.props.teamId, nextProps.teamId)
  }

  getTableKey = (userId, teamId) => {
    return `${userId}@${teamId}`  
  }

  checkProps(currentUserId, nextUserId, currentTeamId, nextTeamId) {
    // Same user, nothing to do
    if (currentUserId === nextUserId && currentTeamId === nextTeamId) {
      return
    }
    // Stop syncing current user info
    if (currentUserId) {
      this.stopSyncingGcalSettings(this.getTableKey(currentUserId, currentTeamId))
    }
    // Start syncing next user info
    if (nextUserId) {
      this.startSyncingGcalSettings(this.getTableKey(nextUserId, nextTeamId))
    }
  }

  startSyncingGcalSettings = key => {
    this.calendarsLoader = new DataLoader(firebase, 'gcal_settings', 'calendars')
    this.props.dispatch(this.calendarsLoader.startSyncing(key))

    this.accessLoader = new DataLoader(firebase, 'gcal_settings', 'access/expiry_date')
    this.props.dispatch(this.accessLoader.startSyncing(key))
  }

  stopSyncingGcalSettings = () => {
    if (this.calendarsLoader) {
      this.calendarsLoader.stopSyncing()
      this.calendarsLoader = undefined
    }
    if (this.accessLoader) {
      this.accessLoader.stopSyncing()
      this.accessLoader = undefined
    }
  }

  render() {
    return null
  }
}

function mapStateToProps(state) {
  const props = {
    userId: state.firebase.userAuth.id
  }
  const userInfo = state.firebase.user
  if (!userInfo) {
    return props
  }
  const userTeams = userInfo.teams
  if (!userTeams || userTeams.loading) {
    return props
  }
  // Just sync first team
  // TODO move this to a selectionTeam key inside redux
  if (userTeams.value && userTeams.value.length > 0) {
    props.teamId = userTeams.value[0].teamId
  }
  return props
}

export default connect(mapStateToProps)(FirebaseGcalSettingsManager)



// WEBPACK FOOTER //
// ./src/infra/components/FirebaseGcalSettingsManager.js